var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2381 59.0418L38.1881 24.456L55.4752 34.4455L35.5277 69.0313L18.2381 59.0418Z",
    fill: "#FBBC04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5924 58.9214L55.63 24.3232C53.0531 19.4453 47.0147 17.5816 42.1408 20.1607C37.2669 22.7399 35.4073 28.7832 37.9818 33.6612C38.0948 33.8751 38.2152 34.0841 38.3429 34.2906L58.3053 68.8887C60.9977 73.7028 67.0802 75.4214 71.8903 72.7267C76.7003 70.032 78.4174 63.9444 75.725 59.1303C75.6808 59.0517 75.6366 58.9755 75.5924 58.8992V58.9214Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9812 73.9486C32.4936 73.9486 36.9623 69.4761 36.9623 63.9591C36.9623 58.4421 32.4936 53.9696 26.9812 53.9696C21.4687 53.9696 17 58.4421 17 63.9591C17 69.4761 21.4687 73.9486 26.9812 73.9486Z",
    fill: "#34A853"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob3);
export default __webpack_public_path__ + "static/media/blob3.b5fa68adb0ed8be79e3eb8cfad021d41.svg";
export { ForwardRef as ReactComponent };